import React, { useCallback, useEffect, useState } from 'react';
import { endpoints } from 'api/endpoints';
import { IconSearch, OrangeButton, IconPlus } from 'components';
import { Input } from 'antd';
import { COLORS } from 'utils/colors';
import { getRequestData } from 'api/api';
import { useNavigate } from 'react-router-dom';
import { ROLE_TYPES } from 'api/constants';
import { useUser } from 'context/userContext';
import { SLHChildCard } from 'pages';
import { useAuth } from 'context/authContext';

export const SLHChilds = () => {
  const { userDetails } = useUser();
  const { parentId } = useAuth();
  const navigate = useNavigate();
  const [partnersList, setPartnersList] = useState();
  const [searchWord, setSearchWord] = useState(null);

  const getChilds = useCallback(async () => {
    if (!userDetails) return;
    const { data } = await getRequestData(
      endpoints.getPartner(parentId ?? userDetails?.partner_details?.id),
      ROLE_TYPES.slh_manager,
    );
    if (data) setPartnersList(data.children);
  }, [parentId, userDetails]);

  useEffect(() => {
    getChilds({ page: 1 });
  }, [getChilds]);

  const storePartners = useCallback(() => {
    const totalItems = partnersList?.length;
    const itemsPerRow = 3;
    const rows = Math.ceil(totalItems / itemsPerRow);
    const startIdxLastRow = (rows - 1) * itemsPerRow;

    return partnersList?.map((partner, index) => {
      const isLastRowItem = index >= startIdxLastRow;

      return (
        <SLHChildCard
          {...partner}
          parentClassName={isLastRowItem}
          key={`${partner.name}-${index}`}
        />
      );
    });
  }, [partnersList]);

  const onSearch = (e) => {
    const searchTerm = e.target.value;

    if (searchTerm.length > 2 || (searchWord && searchWord.length > searchTerm.length)) {
      getChilds({ search: searchTerm });
    }
    setSearchWord(searchTerm);
  };

  return (
    partnersList && (
      <div className="flex flex-col w-full">
        <div className="flex justify-between w-full">
          <p className="nunito-title uppercase">Child SLH</p>
          <div className="flex items-center gap-x-6">
            <Input
              className="search w-[300px] text-lightBlue text-16 rounded-ten bg-light"
              type="text"
              placeholder="Search"
              addonBefore={<IconSearch color={COLORS.lightBlue} />}
              onChange={onSearch}
            />
            <OrangeButton
              onClick={() => navigate('/create-partner')}
              label="Add new child"
              icon={<IconPlus />}
            />

            {/* {partnersList && <DownloadPartnersCSV list={partnersList} />} */}
          </div>
        </div>
        {partnersList && (
          <div className="flex flex-wrap items-stretch w-full gap-4 mt-6">{storePartners()}</div>
        )}
        {/* <Pagination
        className='self-center'
        onChange={page => getChilds({ search: searchWord, page })}
        pageCount={partnersList.pageCount}
        pageSize={10}
        total={partnersList.count}
        current={partnersList.currentPage}
        showSizeChanger={false}
      /> */}
      </div>
    )
  );
};
